// Row 28.1 — the docs registry. 2 pages this batch (disclosed as partial coverage, CFR-HELP01-04
// — not exhaustive end-user documentation). Each entry's content is genuinely self-authored and
// verifiable against the actual shell code, not fabricated placeholder copy.
import gettingStarted from "./content/getting-started.md?raw";
import keyboardShortcuts from "./content/keyboard-shortcuts.md?raw";

export interface DocPage {
  id: string;
  titleKey: string;
  content: string;
}

export const DOC_PAGES: DocPage[] = [
  { id: "getting-started", titleKey: "docs.gettingStarted", content: gettingStarted },
  { id: "keyboard-shortcuts", titleKey: "docs.keyboardShortcuts", content: keyboardShortcuts },
];
